Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var components_footer_Component = require('./Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"footer":"side-panel__footer_xhgyf","sticky":"side-panel__sticky_xhgyf"};
require('./mobile.css');

var FooterMobile = function (_a) {
    var _b;
    var className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, restProps = tslib.__rest(_a, ["className", "sticky", "layout"]);
    return (React__default.default.createElement(components_footer_Component.Footer, tslib.__assign({ className: cn__default.default(className, styles.footer, (_b = {},
            _b[styles.sticky] = sticky,
            _b)), sticky: sticky, layout: layout }, restProps)));
};

exports.FooterMobile = FooterMobile;
